// 短視頻 一行三個
import { CmsGridWrapper } from 'commonStyledComponents'
import VideoBox from 'component/VideoBoxVertical'
import { memo, useMemo } from 'react'

interface Template102Props {
  videoData: any[]
  trigger?: React.ReactNode
  currentLimit?: number
}

/**
 * 模板 ID: "102": 豎版一行三個
 * */
function Template102({ videoData, trigger, currentLimit }: Template102Props) {
  const shortInfo = useMemo(
    () => ({
      list: videoData,
    }),
    [videoData]
  )

  return (
    <CmsGridWrapper>
      {videoData?.slice(0, currentLimit).map((item, i) => {
        return <VideoBox overflow={true} columns={3} key={i} videoInfo={item} shortInfo={shortInfo} allowUnload />
      })}
      {trigger}
    </CmsGridWrapper>
  )
}

// this indicate areaBox should hide bottom section until fully shown
;(Template102 as any).lazy = true
export default memo(Template102)
